import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import api, { wsURL } from "../../../../../../api/api";
import AssignmentTimer from "../../../../../../components/assignmentTimer/AssignmentTimer";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import useSubmitAssignment from "../../../../../../hooks/useAssignmentSubmission";
import useWebSocketConnection from "../../../../../../hooks/useWebSOcketConnection";
import {
  fetchSubmissionTicket,
  computeAttestationProof,
} from "../../../../../../utils/submissionAttestation";
import Question from "../../../questions/Question";
import StudentAssignmentScore from "./StudentAssignmentScore";
import BackButton from "../../../../../../components/BackButton/BackButton";
import CongratulationsPopup from "../../../../../../../src/components/CongratulationsPopup/CongratulationsPopup";
import QuestionNew from "../../../questions/Question_new";
import { CircularProgress, Grid } from "@mui/material";
import StudentLessonPreview from "./StudentLessonPreview";
import "./StudentAssignmentPreview.css";
import { check_image } from "../../../../../../assets/images/images";
import { getPracticeAssignments } from "../../../../../../state/actions/getPracticeAssignmentsAction";
import CustomSingleButtonPopup from "../../../../../../components/CustomSingleButtonPopup/CustomSingleButtonPopup";
import FloatingAIButton from "../../../../../../components/FloatingAIButton/FloatingAIButton";
import {
  setDrawerState,
  setIsWebAllowed,
  setQueryMetaData,
  setAgentData,
  setInitialProjectId,
} from "../../../../../../state/reducers/chatDrawerReducers";

const StudentAssignmentPreview = () => {
  const globalState = useSelector((state) => state.globalState);
  const studentId = globalState.student_details?.data?.student_id ?? "";
  const navigate = useNavigate();
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  const location = useLocation();
  const course = location.state?.course || {};

  const { assignment_id, course_id, lesson_id } = useParams();

  const [showCongratulations, setShowCongratulations] = useState(false);

  useEffect(() => {
    if (showCongratulations) {
      setTimeout(() => {
        setShowCongratulations(false);
      }, 2000);
    }
  }, [showCongratulations]);

  const { token } = useAuth();
  const [assignment, setAssignment] = useState(
    location?.state?.assignment || {},
  );

  const lesson = location?.state?.lesson || {};

  const [assignmentIndex, setAssignmentIndex] = useState(0);
  const [detailedResult, setdetailedResult] = useState(false);
  // const [showScorePopup, setshowScorePopup] = useState(false);
  const [answeredList, setAnsweredList] = useState(
    JSON.parse(
      localStorage.getItem(
        `studentAssignmentProgressDtls${assignment_id}${token}`,
      ),
    ) || [],
  );
  const [getSubmissiondtls, setSubmissiondtls] = useState(
    localStorage.getItem(`getSubmissiondtlsData${assignment_id}${token}`)
      ? JSON.parse(
        localStorage.getItem(`getSubmissiondtlsData${assignment_id}${token}`),
      )
      : [],
  );
  const [showScorePopup, setshowScorePopup] = useState(
    JSON.parse(
      localStorage.getItem(
        `congratulationMessgaePopUp${assignment_id}${token}`,
      ),
    ) || false,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isSessionDisconnected, setIsSessionDisconnected] = useState(false);
  const [isVideoBlocked, setIsVideoBlocked] = useState(false);

  const isSessionDisconnectedRef = useRef(false);

  const [isAssignmentLoading, setisAssignmentLoading] = useState(false);
  const [isWebsocketConnection, setIswebsocketConnection] = useState(false);
  const [showSubmit, setShowPopup] = useState(false);
  const [tabSwitchPopUp, setTabSwitchPopUp] = useState(false);
  const [countdown, setCountdown] = useState(15);
  const countdownRef = useRef(null); // to keep track of interval id
  const timerRunningRef = useRef(false);

  const [tabSwitchCount, setTabSwitchCount] = useState(0);
  const [isMathKeyboardOpen, setIsMathKeyboardOpen] = useState(false);//bb
  const [assignmentClockTimer, setassignmentClockTimer] = useState(true);
  const dispatch = useDispatch();
  const [isLessonPreviewEnabled, setIsLessonPreviewEnabled] = useState(false);
  const socketRef = useRef(null);
  const isSocketReadyRef = useRef(false);
  // Submission attestation. `isAttestedRef` starts true so the client works when
  // the backend runs SUBMISSION_ATTESTATION_MODE=off (server never challenges). If
  // a challenge arrives it flips false until attest_ok. `ticketRef` holds the
  // single-use ticket for the current connection so the challenge handler can sign.
  const isAttestedRef = useRef(true);
  const ticketRef = useRef(null);
  const [
    isVirtualAssistantPreviewEnabled,
    setIsVirtualAssistantPreviewEnabled,
  ] = useState(false);
  const [isTimerPaused, setIsTimerPaused] = useState(true);

  const [timers, setTimers] = useState(
    Array(assignment?.assignment_json?.length).fill(0),
  );
  const [currentStep, setCurrentStep] = useState(0);
  const assignmentJSON = assignment?.assignment_json?.map((item) => {
    return { ...item, student_answer: null, time_taken: "0" };
  });

  const [skippedQuestions, setSkippedQuestions] = useState(
    Array(assignmentJSON?.length).fill(false), // Initialize all as false
  );

  const tabSwitchCountRef = useRef(tabSwitchCount);
  const tabSwitchPopUpRef = useRef(tabSwitchPopUp);
  const isTimerPausedRef = useRef(isTimerPaused);
  const isWebsocketConnectionRef = useRef(isWebsocketConnection);
  const isAssignmentLoadingRef = useRef(isAssignmentLoading);

  useEffect(() => {
    const gettabCount = JSON.parse(
      localStorage.getItem(
        `sAPDtls_AssignmentIdWithSwitchTabCount${assignment_id}${token}`,
      ),
    );

    if (gettabCount && gettabCount.length > 0) {
      const parsedArray = gettabCount;

      // Find the object with matching assignment_id
      const foundItem = parsedArray.find(
        (item) => item.assignment_id === assignment_id,
      );

      if (foundItem) {
        setTabSwitchCount(foundItem.count || 0);
      }
    }
  }, [assignment_id, token]);

  useEffect(() => {
    tabSwitchCountRef.current = tabSwitchCount;
  }, [tabSwitchCount]);

  useEffect(() => {
    isSessionDisconnectedRef.current = isSessionDisconnected;
  }, [isSessionDisconnected]);

  useEffect(() => {
    tabSwitchPopUpRef.current = tabSwitchPopUp;
  }, [tabSwitchPopUp]);

  useEffect(() => {
    isTimerPausedRef.current = isTimerPaused;
  }, [isTimerPaused]);

  useEffect(() => {
    isWebsocketConnectionRef.current = isWebsocketConnection;
  }, [isWebsocketConnection]);

  useEffect(() => {
    isAssignmentLoadingRef.current = isAssignmentLoading;
  }, [isAssignmentLoading]);

  const handleClick = () => {
    delayedExitFullscreen();

    // Additional socket check
    // if (!socketRef.current || socketRef.current.readyState !== WebSocket.OPEN) {
    //   console.error('Socket is not available for submission');
    //   // You might want to show an error message to the user here
    //   return;
    // }

    setShowPopup(true);
    setassignmentClockTimer((prevIsRunning) => !prevIsRunning);

    handleSubmitAssignment();
  };

  const restrictedTimeRef = useRef(true);
  const assignmentType = assignment?.course_type;
  // console.log("assignmentType", assignmentType);

  useEffect(() => {
    const savedTimers =
      JSON.parse(
        localStorage.getItem(`assignmentTimers${assignment_id}${token}`),
      ) || [];
    const total = savedTimers.reduce((acc, curr) => acc + curr, 0);
    const totalDuration = assignment?.duration_minutes * 60;

    // Calculate the remaining time (totalDuration - elapsed time)
    const remainingTime = totalDuration - total;

    // Check if the total time has elapsed, and the restrictedTimeRef is still true
    if (
      remainingTime <= 0 &&
      restrictedTimeRef.current &&
      assignmentType === 2
    ) {
      handleClick();
      restrictedTimeRef.current = false; // Set the flag to false to prevent repeated calls
    }
  }, [timers, assignment?.duration_minutes]);

  const practiceAssignments = useSelector(
    (state) => state.getPracticeAssignments,
  );

  useEffect(() => {
    localStorage.setItem(
      `congratulationMessgaePopUp${assignment_id}${token}`,
      showScorePopup,
    );
    localStorage.setItem(
      `getSubmissiondtlsData${assignment_id}${token}`,
      JSON.stringify(getSubmissiondtls),
    );
  }, [showScorePopup, getSubmissiondtls, assignment_id, token]);

  const [startIndex, setStartIndex] = useState(1);
  const [lastIndex, setLastIndex] = useState(assignmentJSON?.length);
  const [rangIndex, setRangIndex] = useState(4);

  useEffect(() => {
    const sAPDtls_AssignmentId = localStorage.getItem(
      `sAPDtls_AssignmentId${assignment_id}${token}`,
    );

    if (sAPDtls_AssignmentId && sAPDtls_AssignmentId == assignment_id) {
      const sAProgressDtls = localStorage.getItem(
        `studentAssignmentProgressDtls${assignment_id}${token}`,
      );
      if (sAProgressDtls) {
        setAnsweredList(JSON.parse(sAProgressDtls));
        const sAPCurrentStep = localStorage.getItem(
          `studentAssignmentProgressCurrentStep${assignment_id}${token}`,
        );
        setCurrentStep(Number(sAPCurrentStep));
        const sAPCurrentStepForQuestion = localStorage.getItem(
          `studentAssignmentProgressCurrentStepForQuestion${assignment_id}${token}`,
        );
        setStartIndex(sAPCurrentStepForQuestion);
      }
    }
  }, []);

  useEffect(() => {
    // console.log("assignment_id", assignment_id);
    if (location?.state?.type === 1) {
      if (assignment_id) {
        getAssignment(assignment_id);
      }
    }
    if (location?.state?.type === 2) {
      dispatch(
        getPracticeAssignments(
          location?.state?.assignment?.assignment_id,
          token,
          assignmentType,
        ),
      );
    }
    // countCompletedLessons(assignmentDtls);
  }, [lesson_id, assignment_id]);

  useEffect(() => {
    if (practiceAssignments.practiceassignments.length > 0) {
      setisAssignmentLoading(false);

      const matchingPracAssigns =
        practiceAssignments.practiceassignments.filter(
          (pracAssign) => pracAssign.id === location?.state?.assignment?.id,
        );
      const totallengthAssignment = matchingPracAssigns.length - 1;
      let pracAssign = matchingPracAssigns[totallengthAssignment];
      setAssignment(pracAssign);

      setIsLessonPreviewEnabled(pracAssign?.lesson_preview);
      setIsVirtualAssistantPreviewEnabled(pracAssign?.virtual_assistant);
      // if (
      //   !pracAssign ||
      //   !pracAssign.assignment_status ||
      //   !pracAssign.assignment_status.status
      // ) {
      //   // console.log("Triggering createAssignmentStatus");
      //   createAssignmentStatus(location?.state?.assignment?.id);
      // }
      setIsTimerPaused(false);
    }
  }, [practiceAssignments]);

  const getAssignment = async () => {
    setisAssignmentLoading(true);

    const endpoint =
      assignmentType === 2
        ? `competitive/assignments/get-assignment/${assignment_id}/`
        : `assignments/get-assignment/${assignment_id}/`;

    await api
      .get(endpoint, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setisAssignmentLoading(false);
          setAssignment(response?.data?.data);
          setIsLessonPreviewEnabled(response?.data?.data?.lesson_preview);
          setIsVirtualAssistantPreviewEnabled(
            response?.data?.data?.virtual_assistant,
          );
          //   response?.data?.data?.virtual_assistant
          // );
          setIsTimerPaused(false);

          const assignmentData = response?.data?.data;

          // if (
          //   !assignmentData &&
          //   !assignmentData.assignment_status &&
          //   !assignmentData.assignment_status.status
          // ) {
          //   createAssignmentStatus(assignment_id);
          // }
        }
      })
      .catch(() => {
        setisAssignmentLoading(false);
      });
  };

  const enterFullscreen = () => {
    const elem = document.documentElement;
    if (elem.requestFullscreen) elem.requestFullscreen();
    else if (elem.mozRequestFullScreen) elem.mozRequestFullScreen();
    else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
    else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
  };

  // Force exit fullscreen - more aggressive approach
  const forceExitFullscreen = () => {
    // Check if we're actually in fullscreen
    const isFullscreen = !!(
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    );

    if (!isFullscreen) {
      console.log("Not in fullscreen mode, no need to exit");
      return;
    }

    // Try all methods
    const exitMethods = [
      () => document.exitFullscreen && document.exitFullscreen(),
      () => document.webkitExitFullscreen && document.webkitExitFullscreen(),
      () => document.mozCancelFullScreen && document.mozCancelFullScreen(),
      () => document.msExitFullscreen && document.msExitFullscreen(),
    ];

    exitMethods.forEach((method, index) => {
      try {
        const result = method();
        if (result && typeof result.then === "function") {
          // Security: separate dynamic data from format string
          result.catch((err) =>
            console.log("Exit method", index + 1, "failed:", err),
          );
        }
      } catch (error) {
        // Security: separate dynamic data from format string
        console.log("Exit method", index + 1, "threw error:", error);
      }
    });
  };

  // Delayed exit fullscreen with retry
  const delayedExitFullscreen = () => {
    // Try immediately
    forceExitFullscreen();

    // Try again after 500ms
    setTimeout(() => {
      const stillFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );

      if (stillFullscreen) {
        forceExitFullscreen();
      }
    }, 500);

    // Final attempt after 1000ms
    setTimeout(() => {
      const stillFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );

      if (stillFullscreen) {
        forceExitFullscreen();
      }
    }, 1000);
  };

  // Function to start the countdown timer popup

  const startCountdownPopup = () => {
    if (!restrictedTimeRef.current) {
      return;
    }
    if (assignment?.course_type === 1) {
      return;
    }
    if (timerRunningRef.current) {
      return;
    }

    const currentCount = tabSwitchCountRef.current;
    const tabSwitchPopUp = tabSwitchPopUpRef.current;
    const isTimerPaused = isTimerPausedRef.current;
    const isWebsocketConnection = isWebsocketConnectionRef.current;
    const isAssignmentLoading = isAssignmentLoadingRef.current;

    timerRunningRef.current = true;

    if (
      !tabSwitchPopUp &&
      !isTimerPaused &&
      isWebsocketConnection &&
      !isAssignmentLoading
    ) {
      if (currentCount > 0) {
        setTabSwitchPopUp(false);

        // Direct submission with socket check - AVOID calling handleClick()
        const submitWithSocketCheck = () => {
          if (
            isSocketReadyRef.current &&
            socketRef.current &&
            socketRef.current.readyState === WebSocket.OPEN
          ) {
            // Use the more aggressive exit method
            delayedExitFullscreen();

            // Call handleSubmitAssignment directly instead of handleClick
            setShowPopup(true);
            setassignmentClockTimer(false);
            const assignmentData =
              JSON.parse(
                localStorage.getItem(
                  `studentAssignmentProgressDtls${assignment_id}${token}`,
                ),
              ) || [];
            handleSubmitAssignment(assignmentData); // Direct call
          } else {
            setTimeout(submitWithSocketCheck, 100);
          }
        };

        setTimeout(submitWithSocketCheck, 1000);
      } else {
        setCountdown(15);
        setTabSwitchPopUp(true);

        const parsedArray =
          JSON.parse(
            localStorage.getItem(
              `sAPDtls_AssignmentIdWithSwitchTabCount${assignment_id}${token}`,
            ),
          ) || [];
        const index = parsedArray.findIndex(
          (item) => item.assignment_id === assignment_id,
        );

        if (index !== -1) {
          parsedArray[index] = {
            assignment_id: assignment_id,
            count: currentCount + 1,
          };
        } else {
          parsedArray.push({
            assignment_id: assignment_id,
            count: currentCount + 1,
          });
        }

        localStorage.setItem(
          `sAPDtls_AssignmentIdWithSwitchTabCount${assignment_id}${token}`,
          JSON.stringify(parsedArray),
        );

        setTabSwitchCount((prevCount) => prevCount + 1);
      }
    }

    if (countdownRef.current) clearInterval(countdownRef.current);
    countdownRef.current = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);
  };

  // Detect fullscreen exit
  useEffect(() => {
    const handleFullscreenChange = () => {
      if (
        !document.fullscreenElement &&
        !document.webkitFullscreenElement &&
        !document.mozFullScreenElement &&
        !document.msFullscreenElement
      ) {
        console.log("User exited fullscreen");
        startCountdownPopup();
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange,
      );
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange,
      );
      document.removeEventListener(
        "MSFullscreenChange",
        handleFullscreenChange,
      );
    };
  }, []);

  // Detect tab switch using visibility change
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log("User switched tab");
        startCountdownPopup();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      dispatch(setDrawerState(false));
    };
  }, []);

  // Auto-submit when countdown ends
  useEffect(() => {
    if (tabSwitchPopUp && countdown <= 0) {
      if (countdownRef.current) {
        clearInterval(countdownRef.current);
        countdownRef.current = null;
      }
      timerRunningRef.current = false; // mark timer as stopped
      console.log("Auto-submitting due to timeout");

      // Use the more aggressive exit method
      delayedExitFullscreen();

      // Your submit logic here
      setTabSwitchPopUp(false);
      handleClick();
      // alert("Auto submitting assignment due to timeout!");
    }
  }, [countdown, tabSwitchPopUp]);

  // User clicks OK on popup
  const handlePopUp = () => {
    if (countdownRef.current) {
      clearInterval(countdownRef.current);
      countdownRef.current = null;
    }
    timerRunningRef.current = false; // mark timer as stopped
    setTabSwitchPopUp(false);
    enterFullscreen();
  };

  const totalSteps = assignmentJSON?.length;
  const [getSocket, setSocket] = useState(null);

  const handleNext = async (answeredQuestion) => {
    const existingIndex = answeredList.findIndex(
      (question) => question.question_id === answeredQuestion.question_id,
    );

    let updatedList;
    if (existingIndex !== -1) {
      updatedList = answeredList.map((question, index) =>
        index === existingIndex ? answeredQuestion : question,
      );
    } else {
      updatedList = [...answeredList, answeredQuestion];
    }

    setAnsweredList(updatedList);
    localStorage.setItem(
      `sAPDtls_AssignmentId${assignment_id}${token}`,
      assignment_id,
    );

    localStorage.setItem(
      `studentAssignmentProgressDtls${assignment_id}${token}`,
      JSON.stringify(updatedList),
    );

    const student_answer =
      JSON.parse(
        localStorage.getItem(
          `studentWholeAssignmentProgressDtls${assignment_id}${token}`,
        ),
      ) || [];
    if (student_answer.length - 1 < currentStep) {
      student_answer.push(answeredQuestion);
    } else {
      student_answer.splice(currentStep, 1, answeredQuestion);
    }
    localStorage.setItem(
      `studentWholeAssignmentProgressDtls${assignment_id}${token}`,
      JSON.stringify(student_answer),
    );

    // Check if current question was skipped
    const wasSkipped = skippedQuestions[currentStep];

    // Mark current question as not skipped (answered)
    const updatedSkippedQuestions = [...skippedQuestions];
    updatedSkippedQuestions[currentStep] = false;
    setSkippedQuestions(updatedSkippedQuestions);

    // Check if there are any remaining skipped questions (true values)
    const hasSkippedQuestions = updatedSkippedQuestions.some(
      (isSkipped) => isSkipped === true,
    );
    const allQuestionsAnswered = updatedList.length === totalSteps;

    if (wasSkipped && hasSkippedQuestions) {
      // Find next skipped question (prioritize questions AFTER current position)
      let nextSkippedIndex = -1;

      // First look after current position
      for (let i = currentStep + 1; i < totalSteps; i++) {
        if (updatedSkippedQuestions[i] === true) {
          nextSkippedIndex = i;
          break;
        }
      }

      // If not found after, look from beginning
      if (nextSkippedIndex === -1) {
        for (let i = 0; i < currentStep; i++) {
          if (updatedSkippedQuestions[i] === true) {
            nextSkippedIndex = i;
            break;
          }
        }
      }

      // Navigate to next skipped question
      setCurrentStep(nextSkippedIndex);
      setStartIndex(nextSkippedIndex + 1);
      localStorage.setItem(
        `studentAssignmentProgressCurrentStep${assignment_id}${token}`,
        nextSkippedIndex,
      );
      localStorage.setItem(
        `studentAssignmentProgressCurrentStepForQuestion${assignment_id}${token}`,
        nextSkippedIndex + 1,
      );
    } else if (allQuestionsAnswered) {
      setShowPopup(true);
      setassignmentClockTimer(false);
    } else if (wasSkipped && !hasSkippedQuestions && allQuestionsAnswered) {
      // Just answered last skipped question - submit
      setShowPopup(true);
      setassignmentClockTimer(false);
    } else if (wasSkipped && !hasSkippedQuestions && !allQuestionsAnswered) {
      // If no skipped questions but not all answered, find next unanswered question
      let nextUnansweredIndex = -1;

      // Look forward first
      for (let i = currentStep + 1; i < totalSteps; i++) {
        const isAnswered = updatedList.some(
          (q) => q.question_id === assignmentJSON[i].question_id,
        );
        if (!isAnswered) {
          nextUnansweredIndex = i;
          break;
        }
      }

      // If not found forward, look backward
      if (nextUnansweredIndex === -1) {
        for (let i = 0; i < currentStep; i++) {
          const isAnswered = updatedList.some(
            (q) => q.question_id === assignmentJSON[i].question_id,
          );
          if (!isAnswered) {
            nextUnansweredIndex = i;
            break;
          }
        }
      }
      // Navigate to next unanswered question
      if (nextUnansweredIndex !== -1) {
        setCurrentStep(nextUnansweredIndex);
        setStartIndex(nextUnansweredIndex + 1);
        localStorage.setItem(
          `studentAssignmentProgressCurrentStep${assignment_id}${token}`,
          nextUnansweredIndex,
        );
        localStorage.setItem(
          `studentAssignmentProgressCurrentStepForQuestion${assignment_id}${token}`,
          nextUnansweredIndex + 1,
        );
      }
    } else if (currentStep < totalSteps - 1) {
      // Regular flow - move to next sequential question
      setCurrentStep(currentStep + 1);
      setStartIndex(startIndex + 1);
      localStorage.setItem(
        `studentAssignmentProgressCurrentStep${assignment_id}${token}`,
        currentStep + 1,
      );
      localStorage.setItem(
        `studentAssignmentProgressCurrentStepForQuestion${assignment_id}${token}`,
        startIndex + 1,
      );
    } else {
      // On last sequential question
      if (hasSkippedQuestions) {
        // Navigate to first skipped question
        const firstSkippedIndex = updatedSkippedQuestions.findIndex(
          (isSkipped) => isSkipped === true,
        );
        setCurrentStep(firstSkippedIndex);
        setStartIndex(firstSkippedIndex + 1);
        localStorage.setItem(
          `studentAssignmentProgressCurrentStep${assignment_id}${token}`,
          firstSkippedIndex,
        );
        localStorage.setItem(
          `studentAssignmentProgressCurrentStepForQuestion${assignment_id}${token}`,
          firstSkippedIndex + 1,
        );
      } else if (allQuestionsAnswered) {
        setShowPopup(true);
        setassignmentClockTimer(false);
      } else {
        let nextUnansweredIndex = -1;
        for (let i = 0; i < totalSteps; i++) {
          const isAnswered = updatedList.some(
            (q) => q.question_id === assignmentJSON[i].question_id,
          );
          if (!isAnswered) {
            nextUnansweredIndex = i;
            break;
          }
        }

        if (nextUnansweredIndex !== -1) {
          setCurrentStep(nextUnansweredIndex);
          setStartIndex(nextUnansweredIndex + 1);
          localStorage.setItem(
            `studentAssignmentProgressCurrentStep${assignment_id}${token}`,
            nextUnansweredIndex,
          );
          localStorage.setItem(
            `studentAssignmentProgressCurrentStepForQuestion${assignment_id}${token}`,
            nextUnansweredIndex + 1,
          );
        }
      }
    }
  };

  const handleMoveNext = () => {
    if (currentStep < totalSteps - 1) {
      setCurrentStep(currentStep + 1);
      setStartIndex(startIndex + 1);
      localStorage.setItem(
        `studentAssignmentProgressCurrentStep${assignment_id}${token}`,
        currentStep + 1,
      );
      localStorage.setItem(
        `studentAssignmentProgressCurrentStepForQuestion${assignment_id}${token}`,
        startIndex + 1,
      );
    }
  };

  const handleSkip = () => {
    // Mark current question as skipped (true)
    const updatedSkippedQuestions = [...skippedQuestions];
    updatedSkippedQuestions[currentStep] = true;
    setSkippedQuestions(updatedSkippedQuestions);

    let nextIndex = -1;

    // **PRIORITY 1**: Find next UNANSWERED and NOT SKIPPED question
    // Look forward first
    for (let i = currentStep + 1; i < totalSteps; i++) {
      const isAnswered = answeredList.some(
        (q) => q.question_id === assignmentJSON[i].question_id,
      );
      const isSkipped = updatedSkippedQuestions[i];

      if (!isAnswered && !isSkipped) {
        nextIndex = i;
        break;
      }
    }

    // If not found forward, look backward
    if (nextIndex === -1) {
      for (let i = 0; i < currentStep; i++) {
        const isAnswered = answeredList.some(
          (q) => q.question_id === assignmentJSON[i].question_id,
        );
        const isSkipped = updatedSkippedQuestions[i];

        if (!isAnswered && !isSkipped) {
          nextIndex = i;
          break;
        }
      }
    }

    // **PRIORITY 2**: If no unanswered+non-skipped questions exist,
    // navigate to next SKIPPED question (cycling through skipped ones)
    if (nextIndex === -1) {
      // Look forward first for skipped questions
      for (let i = currentStep + 1; i < totalSteps; i++) {
        if (updatedSkippedQuestions[i] === true) {
          nextIndex = i;
          break;
        }
      }

      // If not found forward, wrap around from beginning
      if (nextIndex === -1) {
        for (let i = 0; i < currentStep; i++) {
          if (updatedSkippedQuestions[i] === true) {
            nextIndex = i;
            break;
          }
        }
      }
    }

    // Fallback: stay on current (shouldn't happen)
    if (nextIndex === -1) {
      nextIndex = currentStep;
    }

    // Navigate to next question
    setCurrentStep(nextIndex);
    setStartIndex(nextIndex + 1);
    localStorage.setItem(
      `studentAssignmentProgressCurrentStep${assignment_id}${token}`,
      nextIndex,
    );
    localStorage.setItem(
      `studentAssignmentProgressCurrentStepForQuestion${assignment_id}${token}`,
      nextIndex + 1,
    );
  };

  useEffect(() => {
    if (!assignment_id || !studentId) return;

    // Guards against duplicate/leaked sockets when this effect re-runs (deps
    // change, reconnect, dev Fast-Refresh). `cancelled` lets an in-flight async
    // connect abort if cleanup ran during the ticket fetch; `activeSocket` is the
    // socket THIS run owns, so cleanup closes the right one regardless of state.
    let cancelled = false;
    let activeSocket = null;

    let reconnectAttempts = 0;
    let reconnectInterval = 1000; // Initial reconnect interval in ms
    const maxReconnectInterval = 30000; // Max reconnect interval
    const reconnectDecay = 1.5; // Rate of increase of the reconnect delay
    const maxReconnectAttempts = 5; // Maximum number of reconnect attempts

    // Mirror the submission payload so the ticket the backend issues binds to the
    // same assignment_id/assignment_type the submission carries. Falls back to the
    // URL param when the `assignment` object hasn't loaded yet at connect time.
    const resolveAssignmentType = () => {
      if (assignment?.ass_type === 1) return "competitive";
      if (assignment?.ass_type === 2) return "competitive_practice";
      if (location?.state?.type === 1) return "assignment";
      if (location?.state?.type === 2) return "practice_assignment";
      return undefined;
    };
    const resolveAssignmentId = () => {
      if (location?.state?.type === 1)
        return assignment?.assignment_id ?? assignment_id;
      if (location?.state?.type === 2) return assignment?.id ?? assignment_id;
      return assignment_id;
    };

    // Challenge/response: sign the server's nonce with the per-connection ticket so
    // a copied request from another client can't be replayed. Receives the frame
    // already parsed by onmessage.
    const handleAttestationMessage = async (data) => {
      if (data.type === "attest_challenge") {
        isAttestedRef.current = false;
        try {
          const proof = await computeAttestationProof({
            nonce: data.nonce,
            ticket: ticketRef.current,
          });
          if (socketRef.current?.readyState === WebSocket.OPEN) {
            socketRef.current.send(JSON.stringify({ type: "attest", proof }));
          }
        } catch (err) {
          console.error("Attestation proof failed:", err?.message || err);
        }
      } else if (data.type === "attest_ok") {
        isAttestedRef.current = true;
      } else if (data.type === "not_attested") {
        console.warn("Submission rejected: socket not attested yet.");
      }
    };

    const connectWebSocket = async () => {
      // Fresh single-use ticket right before opening (lives 30s, bound to IP+Origin).
      // Re-fetched on every reconnect so an expired/redeemed ticket never blocks a
      // reconnect. On MODE=off the server ignores it; if the fetch fails we still
      // connect ticketless so off-mode keeps working.
      ticketRef.current = null;
      isAttestedRef.current = true;
      try {
        const t = await fetchSubmissionTicket({
          assignment_id: resolveAssignmentId(),
          assignment_type: resolveAssignmentType(),
          token,
        });
        ticketRef.current = t?.ticket ?? null;
      } catch (err) {
        console.warn(
          "Submission ticket fetch failed:",
          err?.response?.status || err?.message || err,
        );
      }

      // Effect was torn down while the ticket was in flight — don't open a socket
      // that nothing will clean up.
      if (cancelled) return;

      const baseURL = `${wsURL}ws/v2/assignment_submission/${parseInt(studentId)}/?token=${token}`;
      const newWebSocketURL = ticketRef.current
        ? `${baseURL}&ticket=${encodeURIComponent(ticketRef.current)}`
        : baseURL;

      const ws = new WebSocket(newWebSocketURL);
      socketRef.current = ws; // Assign to ref
      activeSocket = ws; // this run owns it — cleanup closes exactly this one

      isSocketReadyRef.current = false; // Reset ready state

      socketRef.current.onopen = () => {
        console.log("WebSocket connection opened");
        reconnectAttempts = 0; // Reset reconnect attempts
        reconnectInterval = 1000; // Reset reconnect interval
        setIswebsocketConnection(true);
        isSocketReadyRef.current = true; // Mark as ready
      };

      socketRef.current.onmessage = (event) => {
        // Attestation control frames are handled here, not by the submission
        // handler (which would misread them as a score response).
        let data;
        try {
          data = JSON.parse(event.data);
        } catch (e) {
          data = null;
        }
        if (
          data?.type === "attest_challenge" ||
          data?.type === "attest_ok" ||
          data?.type === "not_attested"
        ) {
          handleAttestationMessage(data);
          return;
        }
        handleWebSocketMessage(event);
      };

      // Reconnection logic on close
      socketRef.current.onclose = (event) => {
        if (event.code === 4403) {
          // Attestation refused: no/expired/redeemed ticket, IP/Origin mismatch, or
          // bad proof. Reconnect fetches a fresh ticket, which is the correct retry.
          console.warn(
            "Submission socket refused (4403, attestation):",
            event.reason,
          );
        } else {
          console.log("WebSocket connection closed:", event.reason);
        }
        isSocketReadyRef.current = false; // Mark as not ready
        isAttestedRef.current = true; // reset; next connection re-attests if needed
        setIswebsocketConnection(false);

        if (isSessionDisconnectedRef.current) {
          console.log("Session logged out; skipping reconnect.");
          return;
        }

        if (cancelled) return; // effect torn down — don't reconnect

        if (reconnectAttempts < maxReconnectAttempts) {
          reconnectAttempts++;
          setTimeout(() => {
            if (cancelled) return; // torn down while waiting to reconnect
            reconnectInterval = Math.min(
              reconnectInterval * reconnectDecay,
              maxReconnectInterval,
            );
            console.log(`Reconnecting...`);
            connectWebSocket(); // Attempt to reconnect
          }, reconnectInterval);
        } else {
          console.error(
            "Maximum reconnection attempts reached. Cannot reconnect.",
          );
        }
      };

      // WebSocket error handling
      socketRef.current.onerror = (error) => {
        console.error("WebSocket error:", error);
        isSocketReadyRef.current = false;
        setIswebsocketConnection(false);
        socketRef.current.close(); // Ensure the socket is closed properly
      };
    };

    // Connect WebSocket initially
    connectWebSocket();

    // Cleanup: mark cancelled (aborts any in-flight connect/reconnect) and close
    // the socket THIS run opened — in any state (CONNECTING or OPEN), so a still-
    // connecting socket can't leak. Detach onclose first so our close doesn't fire
    // the reconnect path.
    return () => {
      cancelled = true;
      isSocketReadyRef.current = false;
      if (activeSocket) {
        activeSocket.onclose = null;
        activeSocket.onerror = null;
        try {
          activeSocket.close();
        } catch (e) {
          /* already closed */
        }
      }
    };
  }, [assignment_id, studentId, wsURL]);

  const handleWebSocketMessage = async (event) => {
    try {
      const data = JSON.parse(event.data);
      // console.log("WebSocket message received:", data);

      if (data?.type === "disconnect" && data?.reason === "logout") {
        setIsSessionDisconnected(true);
        setIsLoading(false);
        setShowPopup(false);
        setshowScorePopup(true);
        return;
      }

      setSubmissiondtls(data);
      // setIsLoading(false); // Stop loading when last question is processed
      // console.log("Stopping loader...");
      setIsLoading(false);
      // console.log("Loader stopped.");
      setShowPopup(false);
      setshowScorePopup(true);
      // await getAssignment(lesson_id);
      if (location?.state?.type === 1) {
        console.log(location?.state?.assignment?.assignment_id);
        await getAssignment(location?.state?.assignment?.assignment_id);
      }
      if (location?.state?.type === 2) {
        dispatch(
          getPracticeAssignments(
            location?.state?.assignment?.assignment_id,
            token,
            assignmentType,
          ),
        );
      }
    } catch (error) {
      setIsLoading(false);
      console.error("WebSocket message error:", error);
    }
  };

  const { isLoadingAssignment, error, submitAssignment } = useSubmitAssignment(
    () => socketRef.current, // Pass a function that returns current socket
    handleWebSocketMessage,
  );

  const handleBackToCourse = () => {
    if (location?.state?.goBack) {
      navigate(location?.state?.goBack, { state: "after submission" });
    } else {
      navigate(`/course/${course_id}/`, { state: "after submission" });
    }

    localStorage.removeItem(
      `congratulationMessgaePopUp${assignment_id}${token}`,
    );
    localStorage.removeItem(`getSubmissiondtlsData${assignment_id}${token}`);
    localStorage.removeItem(`timerSeconds${assignment_id}${token}`);
    localStorage.removeItem(`assignmentTimers${assignment_id}${token}`);
    localStorage.removeItem(
      `studentAssignmentProgressOnSelect${assignment_id}${token}`,
    );
    localStorage.removeItem(
      `studentAssignmentProgressDtls${assignment_id}${token}`,
    );
    localStorage.removeItem(`sAPDtls_AssignmentId${assignment_id}${token}`);
    localStorage.removeItem(
      `studentWholeAssignmentProgressDtls${assignment_id}${token}`,
    );
    localStorage.removeItem(
      `studentAssignmentProgressCurrentStep${assignment_id}${token}`,
    );
    localStorage.removeItem(
      `studentAssignmentProgressCurrentStepForQuestion${assignment_id}${token}`,
    );
  };

  const typeValue = location?.state?.type;
  // console.log("location?.state",location?.state);
  const competitive_type = assignment?.ass_type;
  // console.log("competitive_type", competitive_type);

  const handleSubmitAssignment = async (questionAnswers) => {
    // Use the more aggressive exit method
    delayedExitFullscreen();

    // Double-check socket availability
    if (!socketRef.current || socketRef.current.readyState !== WebSocket.OPEN) {
      console.error("WebSocket is not connected. Cannot submit assignment.");
      setIsLoading(false);
      setIsTimerPaused(false);
      setShowPopup(false);
      setassignmentClockTimer(true);
      // Show error message to user
      // alert('Connection error. Please try again.');
      return;
    }

    // Wait for attestation before submitting. Instant no-op when the backend runs
    // MODE=off (isAttestedRef stays true, no challenge issued). Bounded to 5s so a
    // failed handshake can't hang the submit forever — the server then rejects with
    // not_attested rather than silently accepting.
    if (!isAttestedRef.current) {
      await new Promise((resolve) => {
        const startedAt = Date.now();
        const poll = () => {
          if (isAttestedRef.current || Date.now() - startedAt > 5000) resolve();
          else setTimeout(poll, 100);
        };
        poll();
      });
    }

    setIsTimerPaused(true);
    setIsLoading(true);

    // Rest of your existing handleSubmitAssignment code...
    const allQuestions = assignmentJSON?.map((item, index) => {
      const answeredQuestion = answeredList.find(
        (q) => q.question_id === item.question_id,
      );
      return {
        question_id: item.question_id,
        type: item.type,
        question: item.question,
        options: item.options,
        student_answer: answeredQuestion
          ? answeredQuestion.student_answer
          : null,
        ai_answer: item.ai_answer,
        picture_generation: item.picture_generation,
        options_feedback: item.options_feedback,
        time_required: item.time_required,
        time_taken: answeredQuestion ? answeredQuestion.time_taken : "0",
        image: item.image ? item.image : null,
      };
    });

    const currentData = [];
    if (questionAnswers) {
      const remainmingQuestions = [...assignmentJSON].splice(
        questionAnswers.length,
      );
      currentData.push(...questionAnswers, ...remainmingQuestions);
    }

    let assignmentTypePayload;
    if (competitive_type === 1) {
      assignmentTypePayload = "competitive";
    } else if (competitive_type === 2) {
      assignmentTypePayload = "competitive_practice";
    } else {
      if (typeValue === 1) {
        assignmentTypePayload = "assignment";
      } else if (typeValue === 2) {
        assignmentTypePayload = "practice_assignment";
      } else {
        assignmentTypePayload = undefined;
      }
    }

    const payload = {
      assignment_type: assignmentTypePayload,
      student_id: parseInt(studentId),
      assignment_id:
        location?.state?.type === 1
          ? assignment?.assignment_id
          : assignment?.id,
      rubric_id: assignment?.rubric_id ?? null,
      questions_answers: questionAnswers ? currentData : allQuestions,
    };

    try {
      submitAssignment(payload);
    } catch (error) {
      setIsLoading(false);
      console.error("WebSocket error", error);
    }
  };

  const createAssignmentStatus = async (assignment_id) => {
    const payload = {
      student_id: globalState.student_details.data.student_id,
      assignment_id: assignment_id,
      status: 3,
      completed_name: assignment.name,
      assignment_type: location?.state?.type,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    };
    await api
      .post(`assignments/create-assignment-status/`, payload, {
        headers,
      })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          localStorage.setItem("assignmentStatusId", response?.data?.data?.id);
        }
      })
      .catch(() => { });
  };

  const updateAssignmentStatus = async (status_id, score) => {
    const payload = {
      status: 1,
      score: score,
      completed_at: new Date().toISOString(),
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    };
    await api
      .put(`assignments/update-assignment-status/${status_id}/`, payload, {
        headers,
      })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          localStorage.removeItem("assignmentStatusId");
        }
      })
      .catch(() => { });
  };

  const handleBack = (answeredQuestion) => {
    const student_answer =
      JSON.parse(
        localStorage.getItem(
          `studentWholeAssignmentProgressDtls${assignment_id}${token}`,
        ),
      ) || [];
    if (student_answer.length - 1 < currentStep) {
      student_answer.push(answeredQuestion);
      localStorage.setItem(
        `studentWholeAssignmentProgressDtls${assignment_id}${token}`,
        JSON.stringify(student_answer),
      );
    } else {
      student_answer.splice(currentStep, 1, answeredQuestion);
      localStorage.setItem(
        `studentWholeAssignmentProgressDtls${assignment_id}${token}`,
        JSON.stringify(student_answer),
      );
    }
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
      setStartIndex(startIndex - 1);
      setIsTimerPaused(false);
    }
  };

  const handleTimeUp = () => { };

  const isLastQuestion = assignmentJSON?.length === currentStep + 1;

  const showScore = () => {
    setshowScorePopup(false);
  };

  const showDetailedResult = () => {
    setAssignmentIndex(0);
    setdetailedResult(!detailedResult);
  };

  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const [showStudentLessonPreview, setShowStudentLessonPreview] =
    useState(isSwitchOn);

  useEffect(() => {
    setShowStudentLessonPreview(isSwitchOn);
  }, [isSwitchOn]);

  const handleSwitchToggle = () => {
    setIsSwitchOn(!isSwitchOn);
  };

  const getStepNumbers = () => {
    const steps = [];
    const currentIndexVal = currentStep + 1;
    const middleRange = Math.floor(rangIndex / 2);
    let start = Math.max(1, currentIndexVal - middleRange);
    let end = Math.min(lastIndex, currentIndexVal + middleRange);

    if (currentIndexVal <= middleRange) {
      end = Math.min(rangIndex, lastIndex);
    } else if (currentIndexVal >= lastIndex - middleRange) {
      start = Math.max(1, lastIndex - rangIndex + 1);
    }

    if (start > 1) steps.push(1);
    if (start > 2) steps.push("...");

    for (let i = start; i <= end; i++) {
      steps.push(i);
    }

    if (end < lastIndex - 1) steps.push("...");
    if (end < lastIndex) steps.push(lastIndex);

    return steps;
  };

  if (location.state === null) {
    navigate("/dashboard/home");
    return;
  }

  const handleBackBtn = () => {
    navigate(-1);
    delayedExitFullscreen();
  };

  return (
    <>
      <div id="AssingmentMCQs-section">
        <div className="AssingmentMCQs-wrapper">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="AssingmentMCQs-header-main-contaiiner">
                  <div
                    className="view-course-Details-back-btn-folder"
                    id="AssingmentMCQs-back-btn"
                  >
                    {/* <BackButton buttonName={assignment?.name} /> */}
                    <div
                      className="Back_button"
                      onClick={() => handleBackBtn()}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        color: "#0068ff",
                        cursor: "pointer",
                        marginBottom: "26px",
                      }}
                    >
                      <i class="fa-solid fa-chevron-left"></i>
                      <span style={{ padding: " 0px 5px" }}>
                        {assignment?.name}
                      </span>
                    </div>
                  </div>
                  {isLessonPreviewEnabled && (
                    <div className="AssingmentMCQs-show-lesson-preview">
                      <h2>Show Lesson Preview</h2>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={isSwitchOn}
                          onChange={handleSwitchToggle} // Use onChange event
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  )}
                </div>
                {isAssignmentLoading ? (
                  <>
                    <p style={{ textAlign: "center" }}>
                      Loading Assignment... Please wait!
                    </p>
                    <div className="spinner-folder">
                      <Grid
                        height={"50vh"}
                        container
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        <Grid item xs={12}>
                          <CircularProgress size={80} />
                        </Grid>
                      </Grid>
                    </div>
                  </>
                ) : (
                  <div className="AssingmentMCQs-container">
                    {showStudentLessonPreview && (
                      <StudentLessonPreview lesson={lesson} isVideoBlocked={isVideoBlocked} />
                    )}
                    <div className={` my-[auto] mx-0 ${showStudentLessonPreview ? "w-full lg:w-[50%]" : "w-full"
                      }`} >
                      <div
                        className={`AssingmentMCQs-right-section !w-full ${showStudentLessonPreview ? "" : "full-width"
                          }`}
                      >
                        <AssignmentTimer
                          duration={(assignment?.duration_minutes ?? 0) * 60}
                          allotted_time={assignment?.duration_minutes}
                          onTimeUp={handleTimeUp}
                          isTimerPaused={isTimerPaused}
                          timers={timers}
                          setTimers={setTimers}
                          currentStep={currentStep}
                          isAssignmentLoading={isAssignmentLoading}
                          assignmentClockTimer={assignmentClockTimer}
                          courseType={assignmentType}
                          showScorePopup={showScorePopup}
                          hide_timer={assignment?.hide_timer || false}
                        />
                        <div className="AssingmentMCQs-main-wrapper">
                          <div className="step-container">
                            {getStepNumbers().map((step, index) => {
                              const isAnswered = answeredList.some(
                                (question) => question.question_id === step,
                              );
                              const stepchecker =
                                currentStep + 1 === step ? true : false;
                              const isOnlyOneStep = getStepNumbers().length === 1;
                              return (
                                <div
                                  key={index}
                                  className={`step ${stepchecker ? "active" : ""
                                    } ${isAnswered && !stepchecker ? "answered" : ""}
                                  ${isOnlyOneStep && stepchecker ? "centered-step" : ""}`}
                                >
                                  {step}
                                </div>
                              );
                            })}
                          </div>
                          {assignmentJSON?.map((assign, index) => (
                            <>
                              <div key={index}>
                                <Question
                                  duration={
                                    (assignment?.duration_minutes ?? 0) * 60
                                  }
                                  assignment={assign}
                                  currentAssignment={assignmentJSON[currentStep]}
                                  index={index}
                                  currentStep={currentStep}
                                  totalSteps={totalSteps}
                                  handleBack={handleBack}
                                  handleNext={handleNext}
                                  handleSkip={handleSkip}
                                  isLast={isLastQuestion}
                                  lesson={lesson}
                                  course_id={course_id}
                                  lesson_id={lesson_id}
                                  assignment_id={assignment_id}
                                  timers={timers}
                                  virtualAssistant={
                                    isVirtualAssistantPreviewEnabled
                                  }
                                  assignmentType={assignment?.assignment_type}
                                  answeredList={answeredList}
                                  setAnsweredList={setAnsweredList}
                                  courseType={assignmentType}
                                  assignmentContent={assignment}
                                  skippedQuestions={skippedQuestions}
                                  setIsTimerPaused={setassignmentClockTimer}
                                  handleMoveNext={handleMoveNext}
                                  showStudentLessonPreview={showStudentLessonPreview}
                                  isVideoBlocked={isVideoBlocked}
                                  setIsVideoBlocked={setIsVideoBlocked}
                                  setIsMathKeyboardOpen={setIsMathKeyboardOpen}//bb
                                  isLessonPreviewEnabled={isLessonPreviewEnabled}
                                />
                              </div>
                            </>
                          ))}
                        </div>
                      </div>
                    </div>
                    {isVirtualAssistantPreviewEnabled && !isMathKeyboardOpen && (<FloatingAIButton
                      onClick={() => {
                        const agentData = [
                          {
                            key: course?.name || "Course",
                            value: String(course?.course_id || ""),
                          },
                        ];

                        dispatch(setAgentData(agentData));
                        if (course?.course_id) {
                          dispatch(
                            setInitialProjectId(String(course?.course_id)),
                          );
                        }
                        dispatch(setDrawerState(!chatDrawerState.isOpen));
                        dispatch(setIsWebAllowed(false));
                        dispatch(
                          setQueryMetaData({
                            assignmentJSON: assignmentJSON[currentStep],
                            assignment_id: assignment_id,
                          }),
                        );
                      }}
                    />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {showScorePopup && (
          <StudentAssignmentScore
            showScore={showScore}
            getSubmissiondtls={getSubmissiondtls?.ai_evaluation_json}
            onclick={() => {
              handleBackToCourse();
            }}
            title={"Back to course"}
            isCurrentAssignment={true}
            onclick2={showDetailedResult}
            title2={"View Detailed Result"}
            // title3={"Review Assignment"}
            title3={"Practice Assignment"}
            assignment={assignment}
            setshowScorePopup={setshowScorePopup}
            setShowCongratulations={setShowCongratulations}
            isNaviget={true}
            submission_Id={getSubmissiondtls?.submission_id}
            isSessionDisconnected={isSessionDisconnected}
          />
        )}

        {showCongratulations && (
          <CongratulationsPopup
            check_image={check_image}
            des="Assignment is being generated, please wait..."
          />
        )}
        {showSubmit && (
          <form
            action=""
            className="delete-course-form"
            id="delete-AssingmentMCQs-form"
          >
            <div className="delete-course-form-container">
              {isLoading ? (
                <>
                  <p>
                    Submission is in progress. Please keep this browser tab open
                    to ensure your submission completes successfully.
                  </p>
                  <Grid
                    height={"50vh"}
                    xs={12}
                    container
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <CircularProgress size={80} />
                  </Grid>
                </>
              ) : (
                <>
                  <h2>Are you sure you want to submit the assignment?</h2>
                  <div className="delete-course-form-btn-folder">
                    <button
                      type="button"
                      disabled={isLoading}
                      onClick={() => {
                        setIsTimerPaused(false);
                        setShowPopup(false);
                        setassignmentClockTimer(true);
                      }}
                      className="not-delete-btn"
                    >
                      Back
                    </button>
                    {isLoading ? (
                      <div className="loading-spinner-course" />
                    ) : (
                      <button
                        onClick={() => {
                          handleSubmitAssignment();
                        }}
                        type="button"
                        className="delete-btn"
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </>
              )}
            </div>
          </form>
        )}
      </div >

      {tabSwitchPopUp && (
        <CustomSingleButtonPopup
          title={`  If you switch tabs, change windows, or leave this page again, your assignment will be automatically submitted immediately.`}
          btn1={`Ok ${countdown}`}
          btn1Click={() => handlePopUp()}
        />
      )
      }

      {
        detailedResult && (
          <div className="AssignmentViewProgress-mock-test-wrapper">
            <div className="AssignmentViewProgress-mock-test-container max-h-[90vh] overflow-y-auto">
              {
                <QuestionNew
                  assignment={
                    getSubmissiondtls?.student_answers_json?.[assignmentIndex]
                  }
                  wholeAssignment={assignment}
                  ai_evaluation_json={getSubmissiondtls?.ai_evaluation_json}
                  index={assignmentIndex}
                  currentStep={assignmentIndex + 1}
                  totalSteps={getSubmissiondtls?.student_answers_json?.length}
                  handleNext={() =>
                    assignmentIndex <
                      getSubmissiondtls?.student_answers_json?.length - 1
                      ? setAssignmentIndex((p) => p + 1)
                      : null
                  }
                  handleBack={() => setAssignmentIndex((p) => p - 1)}
                  isLast={
                    assignmentIndex ===
                    getSubmissiondtls?.student_answers_json?.length - 1
                  }
                  isFirst={assignmentIndex === 0}
                  close={
                    <span
                      onClick={showDetailedResult}
                      className="AssignmentViewProgress-mock-test-close-btn"
                    >
                      <i className="fa-solid fa-x"></i>
                    </span>
                  }
                  questions={getSubmissiondtls?.ai_evaluation_json?.questions}
                  assignmentType={assignment?.assignment_type}
                  courseType={assignmentType}
                  getSubmissiondtls={getSubmissiondtls}
                  currentAssignment={assignmentJSON[assignmentIndex]}
                />
              }
            </div>
          </div>
        )
      }
    </>
  );
};

export default StudentAssignmentPreview;
